import { Box, styled } from "@mui/material"

export const DrawerContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: 360,
  padding: "18px 21px",
  paddingTop: "64px",
}))

export const DrawerHeaderWrapper = styled(Box)(() => ({
  display: "flex",
  height: "60px",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: "1px soild #000000",
}))

export const DrawerMainContainer = styled(Box)(() => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  height: "100%",
  padding: "20px 0",
}))

export const DrawerSearchContainer = styled(Box)(() => ({}))

export const DrawerMiddle = styled(Box)(() => ({
  flex: 1,
  width: "100%",
  margin: "10px 0",
  padding: "10px",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  flexDirection: "column",
}))

export const ButtonContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  marginTop: "auto",
}))

export const DrawerCancelButton = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "138px",
  height: "40px",
  borderRadius: "4px",
  outline: "1px solid #4A79E7",
  cursor: "pointer",
}))

export const DrawerAssignButton = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "138px",
  height: "40px",
  borderRadius: "4px",
  marginLeft: "38px",
  backgroundColor: "#4A79E7",
  cursor: "pointer",
}))
